import NineMinuteDrill from './NineMinuteDrill';

export default NineMinuteDrill;